module.exports = __webpack_public_path__ + "img/28.5c210d10.png";